import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-1"} maskId="square-filled-radius-0-stroke-1-IconCheckmark1"><path fillRule="evenodd" clipRule="evenodd" d="M20.382 4.69968L10.0886 20.7116L3.59448 12.5939L5.15622 11.3445L9.91148 17.2886L18.6996 3.61816L20.382 4.69968Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark1;
